import Folder from "../utils/services/folderService";
import crudTemplate from "../templates/crudTemplate.js";
import authorizationTemplate from "../templates/authorizationTemplate";

let crud = crudTemplate(Folder);
let authorization = authorizationTemplate(Folder);
const state = {
  ...crud.state,
  ...authorization.state
};
const getters = {
  ...crud.getters,
  ...authorization.getters
};

const actions = {
  ...crud.actions,
  ...authorization.actions
};

const mutations = {
  ...crud.mutations,
  ...authorization.mutations
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
